import { Button } from '@progress/kendo-react-buttons';
import { SvgIcon } from '@progress/kendo-react-common';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { NavLink, useMatch } from 'react-router';
import { DateTimeFormatter } from '../../../formatters';
import { WarningTriangleOutline } from '../../../icons/icons';
import { SETTINGS_ROUTES } from '../../features/settings/router/settings-routes';
import { useAppDispatch, useAppSelector } from '../../hooks/store-hooks';
import { ROUTES } from '../../router/routes';
import { dismissPopupAlerts } from '../../state/slices/global-slice';
export function MonitorPopupAlerts() {
    const isInSettings = useMatch(`/${ROUTES.SETTINGS}/${SETTINGS_ROUTES.monitorAlert.index}/*`);
    const dispatch = useAppDispatch();
    const alerts = useAppSelector((x) => x.global.popupAlerts);

    const dismiss = () => {
        dispatch(dismissPopupAlerts());
    };

    if (alerts.length === 0 || isInSettings) {
        return null;
    }

    return (
        <Dialog
            onClose={dismiss}
            title={
                <span className="d-flex align-items-center gap-1">
                    <SvgIcon icon={WarningTriangleOutline} size="xlarge" />
                    <span>New alerts</span>
                </span>
            }
            contentStyle={{ maxHeight: '80vh', minWidth: 'min(500px, 80vw)', padding: 0 }}>
            <div className="d-flex flex-column h-100 gap-2">
                <div className="secondary-text px-3"> New alerts ({alerts.length}):</div>
                <div className="px-3 min-h-0 h-100 overflow-y-auto">
                    <ul>
                        {alerts.map((x, i) => (
                            <li key={i}>
                                <div>
                                    <strong>{x.subject}</strong>
                                    <span> {x.eventName}</span>
                                </div>
                                <div className="secondary-text">{x.text}</div>
                                <div className="secondary-text">{DateTimeFormatter.formatTime(x.time)}</div>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="px-3 secondary-text">
                    Too many alerts? Go to <NavLink to={`${ROUTES.SETTINGS}/${SETTINGS_ROUTES.monitorAlert.index}`}>settings</NavLink> to
                    change alert options.
                </div>
            </div>
            <DialogActionsBar>
                <Button onClick={dismiss} themeColor={'primary'}>
                    Close
                </Button>
            </DialogActionsBar>
        </Dialog>
    );
}
